import {isEmpty} from 'lodash';
import React, {useCallback, useEffect, useState} from "react";
import {Button} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import PurchaseInfo from "../../Common/CartInfo";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {
    callPurchaseParking,
    getAllParkers,
    getBillingProfile,
    getPaymentData,
    getFacilityInfo,
    setPaymentAuto,
    setPaymentType,
    setReachedCheckout, getPurchaseData
} from "../../../../Store/purchase.slice";
import {ToggleButton} from "@material-ui/lab";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Alert from "@material-ui/lab/Alert";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import ReactMarkdown from "react-markdown";
import {makeStyles} from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import GPICreditCardForm from '../../Common/GPI/GPICreditCardForm';
import GPIBankAccountForm from '../../Common/GPI/GPIBankAccountForm';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export function CheckoutPage() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const {subscription} = useSelector(getPurchaseData);
    const [acceptTerms, setAcceptTerms] = useState(false)
    const [open, setOpen] = useState(false);
    const [showBackdrop, setShowBackdrop] = useState(false);
    const [backendError, setBackendError] = useState(null);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const handleClickOpen = () => {
        setOpen(true)
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleAgree = (accept) => {
        setAcceptTerms(accept);
        handleClose();
    }

    const parkers = useSelector(getAllParkers);
    const billingProfile = useSelector(getBillingProfile);
    const facility = useSelector(getFacilityInfo);
    const declineRecurring = billingProfile.decline_recurring || 'FORBIDDEN';
    const paymentData = useSelector(getPaymentData);
    const handleSubmit = useCallback(async () => {
        setShowBackdrop(true);
        setBackendError(null);
        const response = await dispatch(callPurchaseParking())
        console.log(response);
        if (response.type.endsWith('rejected')) {
            setShowBackdrop(false);
            if (response?.error?.message?.includes('earliest payment application date')) {
                setBackendError({ message: response.error.message });
            } else {
            setBackendError('There is an issue processing your payment. Please review the information entered, and try again.');
            }
        } else {
            history.push('/confirm');
        }
    }, [dispatch, history]);
    useEffect(() => {
        if (declineRecurring === 'FORBIDDEN' && !paymentData.auto_pay) {
            dispatch(setPaymentAuto(true));
        } else if (declineRecurring === 'REQUIRED' && !!paymentData.auto_pay) {
            dispatch(setPaymentAuto(false));
        }
    }, [declineRecurring, dispatch, paymentData.auto_pay])
    useEffect(() => {
        if (!parkers.length) history.push('/');
        else if (!isEmpty(subscription)) history.push('/confirm');
        else {
            dispatch(setReachedCheckout(true));
        }
    }, [dispatch, history, parkers.length, subscription]);
    useEffect(() => {
        if (!facility.use_credit_card) {
            dispatch(setPaymentType('ach'));
        }
    }, [dispatch, facility]);

    let displayAch = true;
    if (paymentData?.achDisabled) {
        displayAch = false;
    } else if (!facility.use_ach) {
        displayAch = false;
    }
    const renderPaymentMethodForm = () => {
        if (paymentData.type === 'cc') {
            return facility.use_credit_card ? <GPICreditCardForm/> : null;
        } else {
            return displayAch ? <GPIBankAccountForm/> : null;
        }
    }
    return <Grid container>
        <Grid item xs={12}><LinearProgress variant="determinate" value={80}/></Grid>
        <Grid item xs={12} md={7}>
            <Grid style={{margin: 3}} container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h5'>Complete Checkout</Typography>
                    <Typography variant='body1'>Enter your payment information and checkout.</Typography>
                </Grid>
                <Grid item xs={12}>
                    <ToggleButtonGroup value={paymentData.type}
                                       onChange={(e, v) => dispatch(setPaymentType(v))} exclusive>
                        {facility.use_credit_card ? <ToggleButton value="cc" data-cy="credit-card-toggle-button">Credit Card</ToggleButton> : null}
                        {displayAch ? <ToggleButton value="ach" data-cy="ach-toggle-button">ACH Payment</ToggleButton> : null}
                    </ToggleButtonGroup>
                </Grid>
                <Grid item xs={12}>
                    {renderPaymentMethodForm()}
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h5'>Recurring Payments</Typography>
                </Grid>
                <Grid item xs={12}>
                    {['ALLOWED'].includes(declineRecurring) && <FormControlLabel control={
                        <Checkbox color="primary" checked={paymentData.auto_pay} onChange={(e, c) => dispatch(setPaymentAuto(c))} data-cy="recurring-payments-ack-checkbox"/>
                    } label='I acknowledge that my selected payment method will be charged each month.'/>}
                    {declineRecurring === 'FORBIDDEN' ? <Typography variant='body1'>
                        Your selected payment method will be charged each month.
                    </Typography> : ''}
                    {declineRecurring === 'REQUIRED' ? <Typography variant='body1'>
                        After you sign up, the parking facility will provide additional recurring payment information.
                    </Typography> : ''}
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h5'>Terms &amp; Conditions</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='body1'>Summary of Key Terms.</Typography>
                </Grid>
                {declineRecurring === 'ALLOWED' || (declineRecurring !== 'REQUIRED' &&  !!paymentData.auto_pay) ? <>
                    <Grid item xs={12}><Typography variant='body2'>Billing Date: Day {billingProfile.billing_day} of every
                        month.</Typography></Grid>
                    <Grid item xs={12}><Typography variant='body2'>Payment Due Date: Day {billingProfile.payment_due_day} of
                        every month.</Typography></Grid>
                    <Grid item xs={12}><Typography variant='body2'>
                        Termination Policy: The account must be terminated by day {billingProfile.termination_notice_day} of
                        the month for the next month.
                    </Typography></Grid>
                </>: ''}
                {!isEmpty(facility.terms_and_conditions_summary) ? <Grid item xs={12}>
                    <ReactMarkdown source={facility.terms_and_conditions_summary}/>
                </Grid>: ''}
                <Grid item xs={12}>
                    <FormControlLabel control={
                        <Checkbox color="primary" checked={acceptTerms} onChange={(e, v) => handleAgree(v)} data-cy="accept-terms-checkbox"/>
                    } label={<Typography variant='body2'>
                        I agree to the <Link component="button" onClick={handleClickOpen} data-cy="terms-and-conditions-link">terms and
                        conditions</Link> for this parking facility.
                    </Typography>}/>
                    <Dialog fullScreen={fullScreen} scroll="paper" open={open} onClose={handleClose}
                            maxWidth={fullScreen ? false : 'md'} fullWidth={!fullScreen}
                            aria-labelledby="terms-modal-title" aria-describedby="terms-modal-desc">
                        <DialogTitle id="terms-modal-title">Terms &amp; Conditions</DialogTitle>
                        <DialogContent dividers>
                            <DialogContentText id="terms-modal-desc" data-cy="terms-and-conditions-dialog-content">
                                <ReactMarkdown source={facility.terms_and_conditions}/>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleAgree(false)} color="secondary" data-cy="terms-and-conditions-disagree-button">Disagree</Button>
                            <Button onClick={() => handleAgree(true)} color="primary" autoFocus data-cy="terms-and-conditions-agree-button">Agree</Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} md={5}><Box m={3}>
                <PurchaseInfo/>
            </Box>
        </Grid>
        {backendError !== null ? <Grid item xs={12}>
            <Alert severity="error">{backendError}</Alert>
        </Grid> : ''}
        <Grid container item xs={12} justify="space-between">
            <Box m={3}><Button size="large" variant="contained" color="secondary"
                               onClick={() => history.goBack()} data-cy="back-button">Back</Button></Box>
            <Box m={3}><Button size="large" variant="contained" color="primary"
                               disabled={!(!isEmpty(paymentData.payment_method_id) && !!acceptTerms)}
                               onClick={handleSubmit} data-cy="purchase-submit-button">Purchase</Button></Box>
        </Grid>
        <>
            <Backdrop className={classes.backdrop} open={showBackdrop}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </>
    </Grid>;
}

export default React.memo(CheckoutPage);
